/**
 * Reports API Client
 * Phase 2: Wholesale Partnership Module
 */

import apiClient from '../client';

const BASE_URL = '/wholesale/reports';

// ===== REPORTS =====

/**
 * Get sales report
 */
export const getSalesReport = async (params = {}) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/sales`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales report:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch sales report',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Get customer performance report
 */
export const getCustomerPerformanceReport = async (params = {}) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/customers`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching customer performance report:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch customer performance report',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Get revenue analysis report
 */
export const getRevenueAnalysisReport = async (params = {}) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/revenue`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching revenue analysis report:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch revenue analysis report',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Get executive summary
 */
export const getExecutiveSummary = async (params = {}) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/summary`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching executive summary:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch executive summary',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

/**
 * Get statement of account for a manufacturing company
 */
export const getManufacturingCompanyStatement = async (companyId, params = {}) => {
  try {
    const response = await apiClient.get(
      `${BASE_URL}/manufacturing-company/${companyId}/statement`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching manufacturing company statement:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch manufacturing company statement',
      status: error.response?.status,
      details: error.response?.data
    };
  }
};

export default {
  getSalesReport,
  getCustomerPerformanceReport,
  getRevenueAnalysisReport,
  getExecutiveSummary,
  getManufacturingCompanyStatement
};
